import { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function ListarOrdenesLaboratorio() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [ordenes, setOrdenes] = useState([]);
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [busqueda, setBusqueda] = useState('');
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    useEffect(() => {
        const hoy = new Date();
        const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const finMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        
        setFechaInicio(inicioMes.toISOString().split('T')[0]);
        setFechaFin(finMes.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionLaboratorio');
        } else if (userdata.up && userdata.up.includes('gestionLaboratorio')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

    }, []);

    const buscarOrdenes = () => {
        if (!fechaInicio || !fechaFin) {
            alert('Por favor seleccione las fechas de inicio y fin');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        const params = {
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            estado: estadoFiltro !== '' ? estadoFiltro : null,
            busqueda: busqueda || null
        };

        axios.get('/ordenes-laboratorio', { params })
            .then(response => {
                if (response.status === 200) {
                    setOrdenes(response.data);
                    setPaginaActual(1);
                }
            })
            .catch(error => {
                console.error('Error al buscar órdenes:', error);
                alert('Error al buscar órdenes: ' + (error.response?.data?.message || error.message));
            });
    };

    const getEstadoColor = (estado) => {
        switch(estado) {
            case 'Pendiente': return 'text-warning';
            case 'En Proceso': return 'text-info';
            case 'Completada': return 'text-primary';
            case 'Entregada': return 'text-success';
            case 'Cancelada': return 'text-danger';
            default: return 'text-muted';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        // Agregar 'T00:00:00' para evitar problemas de zona horaria
        const fechaLocal = new Date(fecha + 'T00:00:00');
        return fechaLocal.toLocaleDateString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const getOrdenesPaginadas = () => {
        const inicio = (paginaActual - 1) * registrosPorPagina;
        const fin = inicio + registrosPorPagina;
        return ordenes.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(ordenes.length / registrosPorPagina);
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="laboratory" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-laboratorio">Laboratorio</Link></li>
                                    <li className="breadcrumb-item">Listado de Órdenes</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Listado de Órdenes de Laboratorio</h1>
                            </div>
                            <div className="col-sm-4">
                                <Link to="/crear-orden-laboratorio" className="btn btn-info float-right">
                                    <i className="fas fa-plus"></i> Nueva Orden
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Filtros de Búsqueda</b></h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha Inicio *</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={fechaInicio}
                                                onChange={(e) => setFechaInicio(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha Fin *</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={fechaFin}
                                                onChange={(e) => setFechaFin(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Estado</label>
                                            <select 
                                                className="form-control" 
                                                value={estadoFiltro}
                                                onChange={(e) => setEstadoFiltro(e.target.value)}
                                            >
                                                <option value="">Todos</option>
                                                <option value="Pendiente">Pendiente</option>
                                                <option value="En Proceso">En Proceso</option>
                                                <option value="Completada">Completada</option>
                                                <option value="Entregada">Entregada</option>
                                                <option value="Cancelada">Cancelada</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Buscar</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="N° orden, paciente..."
                                                value={busqueda}
                                                onChange={(e) => setBusqueda(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <button 
                                            type="button" 
                                            className="btn btn-info"
                                            onClick={buscarOrdenes}
                                        >
                                            <i className="fas fa-search"></i> Buscar Órdenes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Resultados ({ordenes.length} órdenes encontradas)</b></h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr style={{textAlign: 'center'}}>
                                                <th>N° Orden</th>
                                                <th>Fecha Recepción</th>
                                                <th>Paciente</th>
                                                <th>Empresa</th>
                                                <th>Total Trabajos</th>
                                                <th>Estado</th>
                                                <th>Fecha Entrega</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{fontSize: '0.85rem'}}>
                                            {getOrdenesPaginadas().map((orden, index) => (
                                                <tr key={index}>
                                                    <td style={{textAlign: 'center'}}><strong>{orden.numero_orden}</strong></td>
                                                    <td style={{textAlign: 'center'}}>{formatearFecha(orden.fecha_recepcion)}</td>
                                                    <td>{orden.paciente_nombre}</td>
                                                    <td>{orden.empresa_nombre || 'N/A'}</td>
                                                    <td style={{textAlign: 'center'}}>{orden.total_trabajos}</td>
                                                    <td style={{textAlign: 'center'}}>
                                                        <span className={getEstadoColor(orden.estado)}>
                                                            <strong>{orden.estado}</strong>
                                                        </span>
                                                    </td>
                                                    <td style={{textAlign: 'center'}}>
                                                        {formatearFecha(orden.fecha_estimada_entrega)}
                                                        {orden.hora_estimada_entrega && <><br/>{orden.hora_estimada_entrega}</>}
                                                    </td>
                                                    <td style={{textAlign: 'center'}}>
                                                        <Link 
                                                            to={`/detalle-orden-laboratorio/${orden.id}`}
                                                            className="btn btn-sm btn-primary"
                                                            title="Ver Detalle"
                                                        >
                                                            <i className="fas fa-eye"></i>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {getTotalPaginas() > 1 && (
                                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === 1}
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                        >
                                            <i className="fas fa-chevron-left"></i> Anterior
                                        </button>
                                        <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === getTotalPaginas()}
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                        >
                                            Siguiente <i className="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ListarOrdenesLaboratorio;
